import { Blockquote } from '@tiptap/extension-blockquote';

export const CustomBlockquote = Blockquote.extend({
   addAttributes() {
      return {
         format: { default: 'long' },
         attribute: { default: null },
      };
   },
});
